import React from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import {
    Spinner
} from 'react-bootstrap'

// includes
import CategoriesForm from './CategoriesForm'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'

function CategoriesDataView(props) {
    // props    
    const {
        formik,
        currentCategoryView,
        categorySubmitBtnDisabled,
        categoryBtnLoading,
        categoriesPageLoading,

        categoryImage,
        currentCategoryImage,
        setCurrentCategoryImage,
        setIsImageDeleted,
    } = props

    // store url
    const [storeUrl] = useStoreUrl()

    return (
        <div className="category-data-view media-body position-relative">
            <div className="inner border-start st-border-light">
                <div className="app-header-wrapper heading-md mb-3">
                    <p className="app-heading text-capitalize">
                        {(currentCategoryView === "create") && "Create Category"}
                        {(currentCategoryView === "edit") && "Edit Category"}
                        {(currentCategoryView === "createSubCat") && "Create Sub Category"}
                    </p>
                    <p className="app-desc">
                        {(currentCategoryView === "create") &&
                            "Create a category for your products."
                        }
                        {(currentCategoryView === "edit") &&
                            "Edit a category for your products."
                        }
                        {(currentCategoryView === "createSubCat") &&
                            "Create a sub category for your products."
                        }
                    </p>
                </div>

                {/* form */}
                <div className="categories-form">
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        {/* cats form */}
                        <CategoriesForm
                            formik={formik}

                            categoryImage={categoryImage}
                            currentCategoryImage={currentCategoryImage}
                            setCurrentCategoryImage={setCurrentCategoryImage}
                            setIsImageDeleted={setIsImageDeleted}
                        />

                        {/* app card : bottom-bar */}
                        <div className={`app-card page-bottom-action-btns ${props.sideBarVisibility ? "" : "sidebar-expanded"}`}>
                            <div className="app-card-content bg-white border-top st-border-light d-flex align-items-center justify-content-end">
                                {/* <Link to={storeUrl + "/catalog/categories"} className="st-btn st-btn-link no-min-width d-flex align-items-center justify-content-center me-1">
                                    Cancel
                                </Link> */}
                                <button
                                    type="submit"
                                    className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(categorySubmitBtnDisabled || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                    disabled={categorySubmitBtnDisabled}>
                                    {
                                        categoryBtnLoading ? (
                                            <Spinner animation="border" size="sm" />
                                        ) : (
                                            <span>
                                                {(currentCategoryView === "create") && "Create Category"}
                                                {(currentCategoryView === "edit") && "Update Category"}
                                                {(currentCategoryView === "editSubCat") && "Update Category"}
                                                {(currentCategoryView === "createSubCat") && "Create Sub Category"}
                                            </span>
                                        )
                                    }
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {
                categoriesPageLoading ? (
                    <div className="category-page-loading position-absolute h-100 w-100 d-flex justify-content-center">
                        <Spinner animation="border" size="sm" />
                    </div>
                ) : null

            }
        </div>
    )
}

const getDataFromStore = state => {
    return {
        sideBarVisibility: state.common.sideBarVisibility
    };
}

export default connect(getDataFromStore, null)(CategoriesDataView)